export default function getAppDecision(obj) {
  if (!obj) {
    return null;
  }

  const appDecision = {
    a: 'approved',
    p: 'pended',
    success: 'approved',
    pending: 'pended',
  };

  const decisionCode = obj.decision.toLowerCase();
  return appDecision[decisionCode];
}
